import { AgDataGridNode } from '@src/types/agDataGrid'
import * as yup from 'yup'

export const agDataGridNodeSchema = (
  field: string
): yup.SchemaOf<AgDataGridNode> => {
  return yup
    .object({
      id: yup.string().default('0')
    })
    .from(field, 'id', true)
}
